const config = {
    apiBaseUrl: process.env.REACT_APP_API_URL || 'https://localhost:7033',
    appVersion: process.env.REACT_APP_VERSION || '1.0.6',
    endpoints: {
        events: {
            version: '/api/Events/dataversion',
            monthly: '/api/Events/month'
        }
    }
};

export default config; 